<template>
    <div>
        <div class="columns is-multiline toolbar-box action-right">
            <div class="column is-12">
                <h1 class="title is-3 between-center">
                    <span>Show Change Order</span>
                </h1>
            </div>
            <div class="column is-12 action-box">
                <div class="field is-grouped is-grouped-right">
                    <p class="control">
                        <router-link :to="{ name: 'projects.index', params: { slug: 'Example' } }" class="button is-default" >Back</router-link>
                    </p>
                    <p class="control">
                        <a @click.prevent="approve" class="button is-info">Approve</a>
                    </p>
                    <p class="control">
                        <a @click.prevent="confirmCustomDelete" class="button is-danger">Delete</a>
                    </p>
                    <p class="control">
                        <router-link :to="{ name: 'change-orders.edit', params: { slug: 'example', project, proposal } }" class="button is-info">Edit</router-link>
                    </p>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        data () {
            return {
                project: null,
                proposal: null,
            }
        },

        mounted () {
            this.project = this.$route.params.project
            this.proposal = this.$route.params.proposal
        },

        methods: {
            approve() {
                this.$swal.fire({
                    text: 'Change Order has been successfull approved.',
                    icon: 'success'
                })
            },
            confirmCustomDelete() {
                this.$swal.fire({
                    title: 'Deleting contact',
                    text: 'Are you sure you want to <strong>delete</strong> this contact? This action cannot be undone.',
                    confirmText: 'Delete Contact',
                    icon: 'error',
                    hasIcon: true,
                    onConfirm: () => {
                        this.$swal.fire('Contact deleted!')
                    }
                })
            }
        }
    }
</script>
